// extracted by mini-css-extract-plugin
export default {"payments":"Yc-z","header":"Zc-z","adjustMarginAndPaddingNewDesign":"_c-z"};